(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-brevo-welcome-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    const BREVO_WELCOME_POPUP = 'Welcome_Popup_Seen';
    const SCROLL_THRESHOLD = 0.25;

    if (sessionStorage.getItem(BREVO_WELCOME_POPUP)) return;

    document.addEventListener('DOMContentLoaded', () => {
      const popup = document.getElementById('optica-popup');
      if (!popup) return;

      let triggered = false;
      function onScroll() {
        if (triggered) return;
        const scrolled = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return;
        if (scrolled / docHeight >= SCROLL_THRESHOLD) {
          triggered = true;
          window.removeEventListener('scroll', onScroll, { passive: true });
          popup.showModal();
          sessionStorage.setItem(BREVO_WELCOME_POPUP, 'true');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });

      const form = document.getElementById('sib-form');
      const errorEl = popup.querySelector('#error-message');
      const successEl = popup.querySelector('#success-message');
      const btn = popup.querySelector('.optica-popup__submit');

      if (!form) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.style.display = 'none';
        successEl.style.display = 'none';
        btn.disabled = true;
        btn.classList.add('is-loading');

        try {
          await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            mode: 'no-cors',
          });
          successEl.style.display = 'block';
          form.reset();

          btn.classList.remove('is-loading');
          btn.disabled = false;

          const closeBtn = popup.querySelector('.optica-popup__close');
          closeBtn.classList.add('optica-popup__close--countdown');

          setTimeout(() => {
            closeBtn.classList.remove('optica-popup__close--countdown');
            popup.close();
          }, 3000);

        } catch {
          errorEl.style.display = 'block';
        } finally {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-sports-sunglasses-features"] && !Shopify.designMode) return;
  try {
    class SportsAccordionDisclosure extends HTMLElement {
    #details;
    #summary;
    #panel;
    #animation = null;
    #isClosing = false;
    #isExpanding = false;

    connectedCallback() {
      this.#details = this.querySelector('details');
      this.#summary = this.querySelector('summary');
      this.#panel = this.querySelector('.sports-accordion__panel');
      this.#summary.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.#summary?.removeEventListener('click', this.#onClick);
      this.#animation?.cancel();
    }

    #onClick = (event) => {
      event.preventDefault();

      if (this.#prefersReducedMotion()) {
        this.#details.open = !this.#details.open;
        return;
      }

      this.#details.style.overflow = 'hidden';

      if (this.#isClosing || !this.#details.open) {
        this.#expand();
      } else if (this.#isExpanding || this.#details.open) {
        this.#collapse();
      }
    };

    #prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    #expand() {
      this.#isExpanding = true;
      const startHeight = `${this.#details.offsetHeight}px`;
      this.#details.open = true;

      window.requestAnimationFrame(() => {
        const endHeight = `${this.#summary.offsetHeight + this.#panel.offsetHeight}px`;
        this.#animate(startHeight, endHeight, true);
      });
    }

    #collapse() {
      this.#isClosing = true;
      const startHeight = `${this.#details.offsetHeight}px`;
      const endHeight = `${this.#summary.offsetHeight}px`;
      this.#animate(startHeight, endHeight, false);
    }

    #animate(startHeight, endHeight, willBeOpen) {
      this.#animation?.cancel();

      this.#animation = this.#details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );

      this.#animation.onfinish = () => this.#onAnimationFinish(willBeOpen);
      this.#animation.oncancel = () => {
        this.#isClosing = false;
        this.#isExpanding = false;
      };
    }

    #onAnimationFinish(open) {
      this.#details.open = open;
      this.#animation = null;
      this.#isClosing = false;
      this.#isExpanding = false;
      this.#details.style.height = '';
      this.#details.style.overflow = '';
    }
  }

  if (!customElements.get('sports-accordion-disclosure')) {
    customElements.define('sports-accordion-disclosure', SportsAccordionDisclosure);
  }
  } catch(e) { console.error(e); }
})();

})();
